import { getBuildTimestamp } from '../../utils/versionUtils';
import { getOutboundMessage } from './outboundUtils';
export function createLoginOutbound(loginString) {
    return getOutboundMessage({
        _type: 'login',
        parts: [
            { name: 'loginString', stringValue: loginString },
            { name: 'loginUuidString', stringValue: '' },
            { name: 'extFriendsStr', stringValue: '' },
            { name: 'extFriendsCode', stringValue: '' },
            { name: 'currentNetworkId', numberValue: null }, // use server default for this number
            { name: 'currentNetworkCode', stringValue: '' },
            { name: 'extNetworkCredsStr', stringValue: '' },
            { name: 'regSourceId', numberValue: null }, // use server default for this number
            { name: 'regSourceCode', stringValue: '' },
            { name: 'currentSiteId', numberValue: 1 },
            { name: 'uuid', stringValue: '' },
            { name: 'needsJoinPacket', booleanValue: true },
            { name: 'privateLoungeStrs', stringValue: '' }, // actually encoded string[]
            { name: 'privateLoungeId', numberValue: 0 },
            { name: 'cookie', stringValue: '' },
            { name: 'cid', stringValue: '' },
            { name: 'userAgent', stringValue: window.navigator.userAgent, needsEncoding: true },
            { name: 'resX', numberValue: window.screen.width },
            { name: 'resY', numberValue: window.screen.height }
        ]
    });
}
export function createLoginManualOutbound({ username, password, skipReverifyCheck }) {
    return getOutboundMessage({
        _type: 'login_manual',
        parts: [
            { name: 'username', stringValue: username, needsEncoding: true },
            { name: 'password', stringValue: password, needsEncoding: true },
            { name: 'clientBuildTimestamp', numberValue: getBuildTimestamp() || 0 },
            { name: 'skipReverifyCheck', booleanValue: skipReverifyCheck }
        ]
    });
}
export function createChooseUsernameOutbound(username, password, email) {
    return getOutboundMessage({
        _type: 'choose_username',
        parts: [
            { name: 'new_username', stringValue: username, needsEncoding: true },
            { name: 'new_password', stringValue: password, needsEncoding: true },
            { name: 'new_email', stringValue: email, needsEncoding: true },
            { name: 'is_login_scene', booleanValue: true }
        ]
    });
}
export function createVerifyAccountOutbound(uuid) {
    return getOutboundMessage({
        _type: 'verify_account',
        parts: [{ name: 'uuid', stringValue: uuid }]
    });
}
export function createSetWebClientTypeOutbound(rddResult) {
    return getOutboundMessage({
        _type: 'set_web_client_type',
        parts: [{ name: 'json', stringValue: JSON.stringify(rddResult) }]
    });
}
export function createSetDeviceIdOutbound(deviceId) {
    return getOutboundMessage({
        _type: 'set_device_id',
        parts: [{ name: 'deviceId', stringValue: deviceId }]
    });
}
export function createVersionCheckOutbound(overrideClientBuildTimestamp) {
    return getOutboundMessage({
        _type: 'version_check',
        parts: [{ name: 'clientBuildTimestamp', numberValue: overrideClientBuildTimestamp || getBuildTimestamp() || 0 }]
    });
}
export function createCheckRecoverLoginOutbound(uuid) {
    return getOutboundMessage({
        _type: 'check_recover_login',
        parts: [{ name: 'uuid', stringValue: uuid }]
    });
}
export function createCheckAutoReconnectOutbound(sessionUuid) {
    return getOutboundMessage({
        _type: 'check_auto_reconnect',
        parts: [{ name: 'sessionUuid', stringValue: sessionUuid }]
    });
}
